const resolvePath = (object: object, path: string, defaultValue?: string) => path
    .split(/[.[\]'"]/)
    .filter((p) => p)
    .reduce((o: any, p) => {
        return o ? o[p] : defaultValue;
    }, object);

export default resolvePath;
